// extracted by mini-css-extract-plugin
module.exports = {"fixedHeight":"default-app-layout_fixedHeight__Cufd9"};